module.exports = __webpack_public_path__ + "img/hasdispen.cf0f6085.svg";